import classNames from 'classnames';
import {observer} from 'mobx-react';
import React from 'react';
import {ReactNodeGenerator} from '../../../../../../lib/helpers';
import {ClassroomKeyValuesStore} from '../../../../../classroom/stores/ClassroomKeyValuesStore';
import {X9ContentStateStore} from '../../../common/X9ContentStateStore';
import {McqModel} from '../../models';
import {SingleSelectMcqStore} from '../SingleSelectMcqStore';

interface Props {
  contentSnapshotId: number,
  model: McqModel,
  store: X9ContentStateStore
}

function renderSelectAnswer(key: number, item: McqModel): React.ReactNode {
  const answer = item.choices.find(x => x.selected)!;
  return (
    <div className="teacher-answer" key={'answer' + key}>
      {answer.label}
    </div>
  );
}

function* renderer(store: SingleSelectMcqStore): ReactNodeGenerator {
  if (store.model.behavior !== 'single-select')
    return;
  if (store.state === null)
    return;

  const model = store.model;
  const state = store.state;
  const choices = model.choices;
  const selectedIndex = state.selectedIndex;
  const checked = state.checked;
  const correct = checked && selectedIndex !== null && choices[selectedIndex].selected;
  const incorrect = checked && selectedIndex !== null && !(choices[selectedIndex].selected);

  for (let index = 0; index < model.choices.length; index++) {
    let choice = model.choices[index];

    const selected = state.selectedIndex === index;
    const classname = classNames('mcq single-select', {
      selected: selected,
      checked: selected && checked,
      correct: selected && correct,
      incorrect: selected && incorrect
    });
    yield (
      <div className="row" key={index}>
        <div className="col">
          <div className={classname}>
            <div className="form-group">
              <div className="form-check">
                <label className="form-check-label">
                  <input type="radio" className="form-check-input"
                         checked={selected}
                         onChange={() => store.select(index)}
                         disabled={correct}/>
                  {choice.label}
                  {choice.selected && renderSelectAnswer(index, model)}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  yield (
    <div className="row justify-content-end" key="check">
      <div className="col-auto">
        <button className="btn btn-primary" type="button" onClick={store.check}
                disabled={correct}> Check
        </button>
      </div>
    </div>);
}

@observer
export class TeacherSingleSelectMcq extends React.Component<Props> {
  readonly store: SingleSelectMcqStore;

  constructor(props: Readonly<Props>) {
    super(props);
    this.store = new SingleSelectMcqStore(props.contentSnapshotId, props.model, props.store);
  }

  render() {
    return Array.from(renderer(this.store));
  }
}
